module.exports = __webpack_public_path__ + "img/dl2.8a801e1b.png";